import React from 'react';
import { connect } from 'react-redux';
import MiniCartHeaderIcon from '../Components/MiniCartHeaderIcon';
import { toggle, update as updateOrderRowQuantity } from '../Actions/Cart.action';
import { reloadPayment } from '../Actions/Checkout.action';

const MiniCartHeaderIconContainer = props => (
    <MiniCartHeaderIcon {...props} />
)

const mapStateToProps = state => {
    const { cart } = state;
    return {
        ...cart,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        toggle: () => dispatch(toggle()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MiniCartHeaderIconContainer);